<template>
    <el-drawer
      title="Create Notification"
      v-model="isNotificationFormOpen"
      :before-close="closeForm"
      direction="rtl"
      size="50%"
    >
      <el-form :model="notificationForm" ref="ruleFormRef" :label-position="'top'" :rules="rules" label-width="auto" >
        <el-form-item label="Image ( Optional )" prop="image_link">
          <el-upload
            class="upload-demo"
            ref="uploadRef"
            :on-change="handleImageSuccess"
            :auto-upload="false"
            :modal-class="'add-modal-drawer'"
            drag
            list-type="picture"
          >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <template #tip>
              <div class="el-upload__tip">
                jpg/png files with a size less than 500kb
              </div>
            </template>
          </el-upload>
        </el-form-item>
        <el-dialog v-model="dialogVisible">
          <img w-full width="100%"  :src="dialogImageUrl" alt="Preview Image" />
        </el-dialog>
        <el-form-item label="Title" prop="title">
          <el-input v-model="notificationForm.title" :disabled="isNotificationLoading" placeholder="Enter notification title"></el-input>
        </el-form-item>
  
        <el-form-item label="Description" prop="description">
          <el-input
            type="textarea"
            v-model="notificationForm.description"
            :disabled="isNotificationLoading"
            placeholder="Enter notification description"
          ></el-input>
        </el-form-item>
  
        <el-form-item label="Notification Type" prop="notification_type">
          <el-select v-model="notificationForm.notification_type" :disabled="isNotificationLoading" @change="handleTypeChange" placeholder="Select notification type">
            <el-option label="Normal" value="Broadcast"></el-option>
            <el-option label="Unit (Notify with Unit)" value="unit"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Send To" prop="send_to">
          <el-select v-model="notificationForm.send_to" :disabled="isNotificationLoading" placeholder="Select" @change="handleSendToChange">
            <el-option label="Broadcast" value="all"></el-option>
            <el-option label="Specific User" value="user"></el-option>
            <el-option label="CRM User" value="crm"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="CRM Role" prop="crm_role" v-if="notificationForm.send_to == 'crm'">
          <el-select v-model="notificationForm.crm_role" :disabled="isNotificationLoading" clearable placeholder="Select Role">
            <el-option label="Sales" value="2"></el-option>
            <el-option label="Team Leader" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="User ID " prop="user_id" v-if="notificationForm.send_to == 'user'">
          <el-input
            type="number"
            :disabled="isNotificationLoading"
            v-model="notificationForm.user_id"
            placeholder="#ID"
            
          />
        </el-form-item>

        <el-form-item label="Unit ID" prop="id" v-if="notificationForm.notification_type == 'unit'">
          <el-input
            type="number"
            :disabled="isNotificationLoading"
            v-model="notificationForm.id"
            placeholder="#ID"
            
          />
        </el-form-item>
        
        
  
        
        
          
        
      </el-form>
      <template #footer>
          <el-button type="warning" :loading="isNotificationLoading" @click="submitForm">
            <font-awesome-icon icon="fa-solid fa-bell" color="#fff" v-if="!isNotificationLoading" /> 
            <span style="margin-left: 5px;">Push Notification</span>
          </el-button>
          <el-button @click="closeForm" :disabled="isNotificationLoading">Cancel</el-button>
      </template>
    </el-drawer>
  </template>
  
  <script>
  import { ref, computed, defineComponent } from 'vue';
  import { useStore } from 'vuex';
  import { ElMessage, ElMessageBox } from 'element-plus'

  export default defineComponent({
    name: 'NotificationDrawer',
    setup() {
      const store = useStore();
      const uploadRef = ref(null);
      const isNotificationLoading = ref(null);
      const notificationForm = ref({
        title: null,
        description: null,
        notification_type: "Broadcast",
        account_type: null,
        image_link: null,
        id:null,
        user_id:null,
        crm_role:null,
        send_to:null,
      });
      const ruleFormRef = ref(null);
      const rules = {
        title: [{ required: true, message: "Title is required", trigger: "blur" }],
        description: [{ required: true, message: "Description is required", trigger: "blur" }],
        notification_type: [{ required: true, message: "Notification type is required", trigger: "change" }],
        id: [{ required: true, message: "@Required", trigger: "blur" }],
        user_id: [{ required: true, message: "@Required", trigger: "blur" }],
        send_to: [{ required: true, message: "@Required", trigger: "change" }],
        crm_role: [{ required: true, message: "Role is required", trigger: "change" }],
      };
  
      const isNotificationFormOpen = computed(() => store.getters['notifications/isNotificationFormOpen']);
  
      const closeForm = () => {
        ElMessageBox.confirm(
          'You have unsaved changes, save and proceed?',
          'Confirm',
          {
            distinguishCancelAndClose: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Discard Changes',
          }
        )
        .then(() => {
          store.dispatch('notifications/toggleNotificationForm');
          resetForm();
          uploadRef.value.clearFiles();
          ElMessage({
            type: 'success',
            message: 'Changes Discribed',
          })
        })
        .catch(() => {
          
          ElMessage({
            type: 'info',
            message:'Canceld',
          })
        })        
      };
  
      const handleImageSuccess = (file,fileList) => {
        console.log(file);
        notificationForm.value.image_link = file.raw;; // Assuming the API responds with the URL of the uploaded image
      };
      const resetForm = () => {
        const form = ruleFormRef.value; // Access the form instance
        if (!form) return;

        // Reset the form fields
        form.resetFields();
      };
      const submitForm = async () => {
        const form = ruleFormRef.value;
        if (!form) return;
        await form.validate(async (valid, fields) => {
            if (valid) {
                isNotificationLoading.value = true;
                console.log(notificationForm.value);
                await store.dispatch("notifications/pushNotification", notificationForm.value);
                isNotificationLoading.value = false;
                //closeForm(); // Close form after submitting
        
            }
        })
      };
      const handleTypeChange = (value) => {
        if(value =='Broadcast'){
          notificationForm.value.id = null;
        }
      }

      const handleSendToChange = (value) => {
        if(value !=='user'){
          notificationForm.value.user_id = null;
        }
        if(value !=='crm'){
          notificationForm.value.crm_role = null;
        }
      }
      
      return {
        notificationForm,
        handleTypeChange,
        handleSendToChange,
        rules,
        ruleFormRef,
        isNotificationLoading,
        isNotificationFormOpen,
        closeForm,
        resetForm,
        handleImageSuccess,
        submitForm,
        uploadRef,
      };
    },
  });
  </script>
  
  <style scoped>
  /* Add custom styling if needed */
  </style>
  